<template>
  <div class="merchants-shop common-body">
    <div class="ccui-navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回</el-button
      >
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: $store.getters.getBreadcrumb('level1').path }"
          >{{ $store.getters.getBreadcrumb("level1").name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/list-query/singleTab/item-list' }"
          >功能样例</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/list-query/treeTable/item-list' }"
          >树表格</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          <span class="ccui-curr-crumb">新增合同</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="detail-box ccui-clearfix" style="padding: 20px 0">
      <div class="ccui-app-container-detail-body">
        <!--审批状态 icon-->
        <div class="detail-info-el-Label">
          <el-label :type="approving" v-if="approvingStatus"></el-label>
        </div>

        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          class="el-tabs__customize"
        >
          <el-tab-pane label="基本信息" name="first">
            <detailManagement
              ref="addManagement"
              :dataInfo="mcConcMeasureBasic"
            ></detailManagement>
          </el-tab-pane>
          <el-tab-pane label="主合同清单" name="second">
            <pcConcMatProtocolDtl
              ref="pcConcMatProtocol"
              :dataInfo="tableData"
            ></pcConcMatProtocolDtl>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-bottom-guide>
      <ul class="ccui-bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack"
            >返回</el-button
          >
        </li>
        <div class="ccui-bottom-guide-divider" />

        <li>
          <el-button type="bottom" icon="icon-ccui-edit" @click="add"
            >保存</el-button
          >
        </li>
      </ul>
    </el-bottom-guide>
  </div>
</template>

<script>
import { recallContract } from "../api/item-detail";
import { getContractInfo } from "../api/item-detail";
// import { getContractInfo, recallContract, listBill } from "../api/item-detail";
import { ishasAgentId } from "@/basa/utils";
import detailManagement from "./detail-approval/detail-management";
import pcConcMatProtocolDtl from "./detail-approval/pcConcMatProtocolDtl";

export default {
  name: "addPcConcMatProtocol",
  components: {
    detailManagement,
    pcConcMatProtocolDtl
  },
  data() {
    return {
      focus: "pcconcmatprotocol",
      activeName: "first",
      status: "",
      id: "",
      version: "",
      activities: [],
      mcConcMeasureBasic: {},
      tableData: [],
      code: 0,
      approving: "", // 审批状态
      approvingStatus: true, // 审批状态展示
      approvingType: {
        2: "approving", // 审批中
        4: "approvaled", // 审批通过
        5: "sendback", // 已退回
        3: "withdrawn" // 已撤回
      }
    };
  },
  watch: {
    $route(to, from) {
      // 从不同页面进入detail，刷新页面
      console.log(to, from);
      if (to.name === "contracts-management-item-detail-approval") {
        this.activeName = "first";
        this.tableData = [];
        this.getInfo();
      }
    }
  },
  created() {
    // 查询审批流程状态 or 审批记录
    this.getInfo();
    this.activeName = "first";
  },
  methods: {
    async getInfo() {
      // await getContractInfo({})
      //   .then(res => {
      //     console.log(res);
      //     this.status = res.data.data.contractStatus;
      //     this.id = res.data.data.id;
      //     this.version = res.data.data.version;
      //     this.activities = res.data.data.approveRecords;
      //     this.mcConcMeasureBasic = res.data.data;
      //     this.activities.forEach(item => {
      //       if (item.operState == "0") {
      //         item.icon = "el-icon-time";
      //         item.color = "#F5A623";
      //       }
      //     });
      //     this.approving = this.approvingType[res.data.data.contractStatus];
      //     this.approvingStatus = false;
      //     this.$nextTick(() => {
      //       this.approvingStatus = true;
      //     });
      //   })
      //   .then(e => {
      //     console.log(e);
      //   });
      // let obj = {
      //   code: this.code,
      //   contractId: this.id
      // };
      // listBill(obj)
      //   .then(res => {
      //     console.log(res);
      //     this.tableData = res.data.data;
      //   })
      //   .catch(e => {
      //     console.log(e);
      //   });
    },
    handleClick(tab, event) {
      console.log(tab, event, this.activeName);
      this.activeName = tab.name;
    },
    // 返回
    handleBack() {
      this.$router.push("/list-query/treeTable/item-list");
    },
    // 清空
    resetHandle() {
      console.log(this.$refs.formRefs, "formRefsformRefsformRefs");
    },
    // 撤回
    recallHandle() {
      this.$confirm("您确定要撤回吗？", "撤回确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "撤回",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom",
        closeOnClickModal: false
      }).then(() => {
        let obj = {
          id: this.id,
          version: this.version
        };
        this.$loading({
          lock: true,
          text: "撤回中,请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        recallContract(obj)
          .then(res => {
            console.log(res);
            this.$loading().close();
            this.$message({
              message: res.data.message,
              type: "success",
              showClose: true,
              ccuiCustom: true
            });
            this.handleBack();
            // this.$router.push("/management/index/item-list");
          })
          .catch(e => {
            console.log(e);
            this.$loading().close();
          });
      });
    },
    // 提交
    submitHandle() {
      // this.$router.push("/contracts/management/edit-item");
      var pass;
      pass = true;
      // //最后检查主表
      this.$refs.pcConcMatProtocol.$refs.form.validate(valid => {
        if (valid && pass) {
          this.add();
        } else {
          this.errorLocation(this);
          pass = false;
          return false;
        }
      });
    },
    // 保存请求
    add() {
      console.log(11111111111111111);
      console.log(this.$refs.addManagement.form);
      console.log(this.$refs.pcConcMatProtocol.tableData);
      let tPositionKeyBO = this.$refs.addManagement.form;
      let list = this.$refs.pcConcMatProtocol.tableData;

      //主合同登记-查询主合同基本信息
      // list	object []
      // ids	number []
      // tPositionKeyBO
      getContractInfo({
        tPositionKeyBO,
        list
      })
        .then(res => {
          console.log(res);
          if (res.data.code == 0) {
            this.$router.push("/list-query/treeTable/item-list");
          }
        })
        .catch(e => {
          this.$message({
            message: e.data.message,
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        });
    },
    tabChange(item, index) {
      console.log(item);
      this.focus = item[0];
      let jump = document.querySelectorAll(".d_jump");
      console.log(jump);
      // // // 获取需要滚动的距离
      let total = jump[item[1]].offsetTop;
      console.log(total);
      // // Chrome
      document.body.scrollTop = total;
      // // Firefox
      document.documentElement.scrollTop = total;
      // // Safari
      window.pageYOffset = total;
    }
  },
  // 更改列表缓存状态
  beforeRouteLeave(to, from, next) {
    if (this.submitFlag === true) {
      for (var key in this.$vnode.parent.componentInstance.cache) {
        delete this.$vnode.parent.componentInstance.cache[
          ishasAgentId(to.path, key)
        ];
      }
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ccui-form .ccui-form-longInput {
  width: 100%;
}
.ccui-navigation {
  height: 30px;
  margin-top: -5px;
}
.template-body .detail-box {
  margin: 15px 0 80px;
  min-width: 1180px;
}
.detail-info {
  width: calc(100% - 398px);
  min-height: calc(100vh - 260px);
  float: left;
  background: #fff;
  position: relative;
  padding-bottom: 20px;
}
.ccui-app-container-detail-body {
  float: left;
  width: 100%;
  background: #ffffff;
  padding: 20px 20px;
  min-height: calc(100vh - 300px);
  box-sizing: border-box;
  position: relative;
}
/deep/.el-row {
  display: flex;
}
/deep/.el-col-12 {
  width: 50%;
  margin-right: 0;
}
/deep/.approval-read-record {
  margin-top: 0;
}
.el-bottom-guide .el-bottom-guide-container {
  margin: 0 auto;
  min-width: 1080px;
  max-width: 1680px;
  padding: 0 50px;
}
/deep/.detail-info-el-Label {
  position: absolute;
  width: 107px;
  right: 50px;
  top: 31px;
  z-index: 1;
}
</style>
